import './assets/main.css'
import { createApp } from 'vue'
import App from './App.vue'
const app = createApp(App)

// Manage stores to save data in the browser
import { createPinia, setActivePinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { initializeTokenExpirationWatcher } from '@/services/tokenExpirationService'
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(pinia)
setActivePinia(pinia)
initializeTokenExpirationWatcher()

import router from './router'
app.use(router)

import i18n from '../i18n'
app.use(i18n)

app.mount('#app')
